export const propsMap: { [key: string]: InputProps } = {
  alpha: {
    type: "text",
    inputMode: "text",
    pattern: "[a-zA-Z]{1}",
  },

  alphanumeric: {
    type: "text",
    inputMode: "text",
    pattern: "[a-zA-Z0-9]{1}",
  },

  numeric: {
    type: "tel",
    inputMode: "numeric",
    pattern: "[0-9]{1}",
    min: "0",
    max: "9",
  },
};

export type InputProps = {
  type: InputType;
  inputMode: InputMode;
  pattern: string;
  min?: string;
  max?: string;
};

export type MFAInputRef = {
  focus: () => void;
  clear: () => void;
};

export type InputMode = "text" | "numeric";

export type InputType = "text" | "tel" | "password";

export enum ALLOWED_CHARACTER_VALUES {
  ALPHA = "alpha",
  NUMERIC = "numeric",
  ALPHANUMERIC = "alphanumeric",
}

export type MFAInputProps = {
  allowedCharacters?: ALLOWED_CHARACTER_VALUES;
  ariaLabel?: string;
  hasError?: boolean;
  autoFocus?: boolean;
  classes?: {
    inputsContainer?: string;
    container?: string;
    input?: string;
    helperText?: string;
  };
  disabled?: boolean;
  children?: React.ReactNode; // children is for helper text
  length?: number;
  placeholder?: string;
  onChange: (res: string) => void;
  errorMessage?: React.ReactNode;
};

export const enum InputSize {
  sm = "sm",
  md = "md",
}
